// Libraries
import React from 'react';
import PropTypes from 'prop-types';

import AuthResource from 'components/AuthResource';

const FilterSection = ({
    filterActionTitle,
    tableTitle,
    tableFilters,
    onClickTableAction,
    tableActionPopup,
    additionalActions,
    searchAction,
    tableSearch,
    filterActionPermission,
}) => (
    <div className="subFilterSec clearfix">
        {tableTitle ? <h3 className="page-tile">{tableTitle}</h3> : null}
        <div className="subFilter">
            {tableFilters && tableFilters}
            {tableSearch && tableSearch}
            {searchAction && searchAction}
            {tableActionPopup && tableActionPopup}
            {additionalActions && additionalActions()}
            {filterActionTitle ? (
                <AuthResource
                    overridePermission={!filterActionPermission}
                    permission={filterActionPermission}
                >
                    <div
                        className="createAction"
                        id="create-action"
                        onClick={onClickTableAction}
                    >
                        {filterActionTitle}
                    </div>
                </AuthResource>
            ) : null}
        </div>
    </div>
);

FilterSection.propTypes = {
    additionalActions: PropTypes.node,
    tableSearch: PropTypes.node,
    filterActionTitle: PropTypes.string,
    onClickTableAction: PropTypes.func,
    tableActionPopup: PropTypes.node,
    tableFilters: PropTypes.node,
    tableTitle: PropTypes.string,
    searchAction: PropTypes.node,
    filterActionPermission: PropTypes.string,
};

export default FilterSection;
